import React from 'react'
import OllieAskLink from 'src/components/ollie/OllieAskLink'
import { STOCK_TAKE_ASK_OLLIE_QUIET_LABEL } from 'src/utils/stockTakeHud'

const StockTakeAskOllie = ({
  loaded = false,
  afterSavedCount = false,
  askOllie = null,
  onOpen,
  toolbar = false,
}) => {
  if (!loaded) return null
  return (
    <OllieAskLink
      data-testid='stock-take-ask-ollie'
      quiet={!afterSavedCount}
      toolbar={toolbar}
      openEmpty={!afterSavedCount}
      label={
        afterSavedCount
          ? askOllie?.label || 'Ask Ollie about this stock take'
          : STOCK_TAKE_ASK_OLLIE_QUIET_LABEL
      }
      question={afterSavedCount ? askOllie?.question : undefined}
      onOpen={onOpen}
    />
  )
}

export default StockTakeAskOllie
